<div class="content-container quotation-reciever-view__container">
	<section class="data-table invoice all-lists">
		<header class="data-table__header">
			<h1 class="page-heading">
				<svg width="33" height="43" viewBox="0 0 33 43">
					<path d="M31.263 39.7c0 .597-.487 1.084-1.085 1.084H2.388a1.087 1.087 0 0 1-1.085-1.085V7.593c0-.598.487-1.085 1.085-1.085H6.97c-.004.073-.022.143-.022.217v1.952H4.125a.651.651 0 0 0-.651.651v28.636c0 .359.291.65.651.65h24.316c.36 0 .651-.291.651-.65V9.328c0-.359-.292-.65-.651-.65h-2.823V6.724c0-.074-.017-.144-.021-.217h4.58c.599 0 1.086.487 1.086 1.085v32.106zM10.203 4.772h2.606c.36 0 .652-.292.652-.651a2.825 2.825 0 0 1 2.822-2.82 2.825 2.825 0 0 1 2.822 2.82c0 .359.292.65.652.65h2.605c1.077 0 1.954.876 1.954 1.953v1.952H8.25V6.725c0-1.077.876-1.952 1.954-1.952zM27.79 9.979v27.334H4.776V9.979H27.79zm2.389-4.773h-4.954a3.245 3.245 0 0 0-2.862-1.735h-2.006A4.13 4.13 0 0 0 16.283 0a4.131 4.131 0 0 0-4.074 3.471h-2.005a3.245 3.245 0 0 0-2.862 1.735H2.388A2.39 2.39 0 0 0 0 7.593v32.106a2.39 2.39 0 0 0 2.388 2.386h27.79a2.39 2.39 0 0 0 2.388-2.386V7.593a2.39 2.39 0 0 0-2.388-2.387z"/>
					<path d="M16.283 5.64c.36 0 .651-.291.651-.65V3.254a.651.651 0 0 0-1.302 0V4.99c0 .359.291.65.65.65M14.086 15.81l-3.014 3.011-1.276-1.276a.652.652 0 0 0-.921.921l1.737 1.736a.653.653 0 0 0 .921 0l3.474-3.471a.65.65 0 1 0-.921-.921M14.086 21.884l-3.014 3.011-1.276-1.275a.652.652 0 0 0-.921.92l1.737 1.736a.653.653 0 0 0 .921 0l3.474-3.471a.65.65 0 1 0-.921-.92M14.086 27.958l-3.014 3.011-1.276-1.275a.652.652 0 0 0-.921.92l1.737 1.736a.653.653 0 0 0 .921 0l3.474-3.471a.65.65 0 1 0-.921-.92M21.66 19.09h-.217v-1.952a.651.651 0 0 0-1.303 0v1.952h-.217c-1.272 0-2.388 1.115-2.388 2.387v.262c0 .963.666 1.809 1.656 2.106l2.841.85c.427.127.713.472.713.857v.263c0 .491-.484 1.085-1.085 1.085h-1.718c-.612 0-1.105-.594-1.105-1.085v-.867a.651.651 0 0 0-1.302 0v.867c0 1.271 1.125 2.387 2.407 2.387h.198v1.952a.651.651 0 0 0 1.303 0v-1.952h.217c1.272 0 2.388-1.116 2.388-2.387v-.263c0-.965-.66-1.81-1.642-2.105l-2.84-.85c-.436-.13-.729-.475-.729-.858v-.262c0-.492.485-1.085 1.086-1.085h1.737c.6 0 1.085.593 1.085 1.085v.867a.651.651 0 0 0 1.303 0v-.867c0-1.272-1.116-2.387-2.388-2.387"/>
				</svg>
				<ng-container i18n="@@quotations">Quotations</ng-container>
			</h1><!-- data-table__heading -->
		</header>
		<!-- end billing-header -->
		<div class="data-table__wrap">
			<ng-container *ngIf="['create-quote', 'edit-quote', 'view-quote'].indexOf(activeTab) == -1">
			
				<header class="data-table__create-section">
					<div class="search-field">
						<div class="search-icon">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-width="1.5" transform="translate(1 1)">
									<circle cx="7" cy="7" r="7"/>
									<path stroke-linecap="square" d="M13.5 12.5L18 17"/>
								</g>
							</svg>
						</div>
						<input type="text" (keyup)="searchQuotes($event.target.value)" name="search" i18n-placeholder="@@input.search_here" placeholder="Search quotations" #searchInput/>
					</div>
					<div class="create-download">
						<a (click)="switchTab('create-quote')" href="javascript:void(0)" id="create-new-invoice-trigger" data-text="X" class="tu-btn pink">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12"/>
								</g>
							</svg>
							<span i18n="@@common.create_new_quotation">Create new quotation</span>
						</a>

						<a href="javascript:void(0);" class="downloadXl" [hidden]="activeTab =='drafts'" (click)="exportXls()">
							<svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
								<g fill="#0CC5D1" fill-rule="evenodd">
									<path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
									<path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
								</g>
							</svg>
							<span i18n="@@common.download_xls">download .xls</span>
						</a>
					</div>
				</header>

				<div class="data-table__filter">
					<div class="top-filter">
						<div class="left-section">
							<span class="show-text" i18n="@@common.show">Show</span>
							<div class="select-pages">
								<select nice-select  id="tab-links-select" (change)="switchTab($event.target.value)" >
									<option [value]="'all-quotes'" [selected]="activeTab == 'all-quotes'" i18n="@@quotation.all_quotations">
										All Quotations ({{quotesCount}})
									</option>
									<option [value]="'drafts'" [selected]="activeTab == 'drafts'" i18n="@@quotation.drafts">
										Drafts ({{draftsCount}}) 
									</option>
								</select>

								<ul class="nav nav-pills" id="pills-tab" role="tablist">
									<li class="nav-item">
										<a (click)="switchTab('all-quotes')" [class.active]="activeTab =='all-quotes'" class="nav-link" id="pills-all-pill" role="tab" aria-controls="pills-home" aria-selected="true" i18n="@@quotation.all_quotations">All Quotations ({{quotesCount}})</a>
									</li>
									<li class="nav-item">
										<a (click)="switchTab('drafts')" [class.active]="activeTab =='drafts'" class="nav-link" id="pills-draft-pill" role="tab" aria-controls="pills-contact" aria-selected="false" i18n="@@quotation.drafts">Drafts ({{draftsCount}})</a>
									</li>
								</ul>
							</div>
						</div>
						<div class="right-section">
							<a href="javascript:void(0);" class="filters_block_btn filters_options" (click)="toggleFilter()">
								<svg _ngcontent-aii-c108="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="static"><path _ngcontent-aii-c108="" d="M6 12H18M3 6H21M9 18H15" stroke="#0A0A0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
								<span i18n="@@common.filters">Filters</span>
							</a>
						</div>
					</div>
					<div class="body-filter" [class.show]="isFilter">
						<fieldset class="date sl">
							<label i18n="@@common.from_date">From Date</label>
							<div class="date-input-wrap">
								<input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.from_date" placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="quotes-date-range" />
								<!-- <input type="text" data-large-default="true" class="date-input" data-theme="teamup"  /> -->
							</div>
						</fieldset>
						<fieldset class="date sl">
							<label i18n="@@common.to_date">To Date</label>
							<div class="date-input-wrap">
								<input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" i18n-placeholder="@@common.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="quotes-date-range" />
								<!-- <input type="text" data-large-default="true" class="date-input" data-theme="teamup"  /> -->
							</div>
						</fieldset>
						<fieldset class="md">
							<label i18n="@@common.status">Status</label>
							<select nice-select class="nice-select" [(ngModel)]="quotation_status" (change)="filterByStatus()">
								<option i18n="@@option.select_status" value="">Select Status</option>
								<option value="pending" i18n="@@ts.pending">Pending</option>
								<option value="approved" i18n="@@ts.approved">Approved</option>
								<option value="rejected" i18n="@@ts.rejected">Rejected</option>
							</select>
						</fieldset>
						<fieldset class="md">
							<label i18n="@@common.minimum_amount">Minimum amount</label>
							<div class="tag-input">
								<input type="text" [(ngModel)]="minAmount" (keyup)="filterByAmount()" placeholder="100"/>
								<span [innerHtml]="userInfo?.currency_symbol"></span>
							</div>
						</fieldset>
						<fieldset class="md">
							<label i18n="@@common.maximum_amount">Maximum amount</label>
							<div class="tag-input">
								<input type="text" [(ngModel)]="maxAmount" (keyup)="filterByAmount()" placeholder="10,000"/>
								<span [innerHtml]="userInfo?.currency_symbol"></span>
							</div>
						</fieldset>
						<fieldset class="filters_expanded_bottom w-auto">
							<button class="clear_allfilters py-4" (click)="clearAllFilter()">
								<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
									<path d="M13.3333 4.99984V4.33317C13.3333 3.39975 13.3333 2.93304 13.1517 2.57652C12.9919 2.26292 12.7369 2.00795 12.4233 1.84816C12.0668 1.6665 11.6001 1.6665 10.6667 1.6665H9.33333C8.39991 1.6665 7.9332 1.6665 7.57668 1.84816C7.26308 2.00795 7.00811 2.26292 6.84832 2.57652C6.66667 2.93304 6.66667 3.39975 6.66667 4.33317V4.99984M2.5 4.99984H17.5M15.8333 4.99984V14.3332C15.8333 15.7333 15.8333 16.4334 15.5608 16.9681C15.3212 17.4386 14.9387 17.821 14.4683 18.0607C13.9335 18.3332 13.2335 18.3332 11.8333 18.3332H8.16667C6.76654 18.3332 6.06647 18.3332 5.53169 18.0607C5.06129 17.821 4.67883 17.4386 4.43915 16.9681C4.16667 16.4334 4.16667 15.7333 4.16667 14.3332V4.99984" stroke="#EB1461" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								Clear all
							</button>
						</fieldset>
					</div>
				</div>
			</ng-container>

			<!-- <ng-template #closeQuote>
				<div class="data-table__btn-wrap w-100">
					<div class="btn-row">
						<a (click)="goToPreviousTab()" href="javascript:void(0)" id="create-new-invoice-trigger" data-text="X" class="tu-btn-circular pink clicked">
							<svg width="14" height="14" viewBox="0 0 14 14">
								<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
									<path d="M1 7h12M7 1v12"/>
								</g>
							</svg>
						</a>
					</div>
				</div>
			</ng-template> -->
		</div>

		<div class="data-table__wrap">
				<create-quotation 
					*ngIf="activeTab == 'create-quote'" 
					(onCreate)="onCreateQuotation($event)" 
					(changeTab)="switchTab($event)"
				></create-quotation>

				<view-quotation
					*ngIf="activeTab == 'view-quote'" (onCreate)="onCreateQuotation($event)"
					[quotationDetail]="activeQuotation"
					(onEdit)="editQuotation($event)" 
					(doAction)="doAction($event)"
					(onDelete)="onDeleteQuotation($event)"
					(changeTab)="switchTab($event)"
					(quotationAction) = "quotationAction($event)"
				></view-quotation>

				<edit-quotation 
					*ngIf="activeTab == 'edit-quote'" 
					(onEdit)="onEditQuotation($event)" 
					(changeTab)="switchTab($event)"
					[quotation]="activeQuotation">
				</edit-quotation>
				
         	<div class="tab-content data-table__tab-content" id="pills-tabContent">
				<div class="tab-pane fade {{ activeTab == 'all-quotes' ? 'show active' : ''}}" id="pills-view" role="tabpanel" aria-labelledby="pills-view-tab">
					<teemapp-table
						[name]="'quotations'"
						[tableSchema]="quotesTable"
						[selectable]="false"
						(onLoad)="onLoadQuotes($event)"
						(onSelect)="onSelectQuotes($event)"
						#quotesTableRef 
					>
					</teemapp-table> <!-- [menuItems]="quotesMenuItems" -->
				</div>
				<div class="tab-pane fade {{ activeTab == 'drafts' ? 'show active' : ''}}" id="pills-draft" role="tabpanel" aria-labelledby="pills-draft-tab">
				  <teemapp-table 
						[name]="'drafts'"
						[tableSchema]="draftsTable"
						[selectable]="true"
						[menuItems]="draftMenuItems"
						(onLoad)="onLoadDrafts($event)"
						(onSelect)="onSelectDraft($event)"
						#draftsTableRef
					>
					</teemapp-table>
				</div>

				
			</div>
		</div>
		<!-- end data-table__wrap -->
	</section>
	<!-- end data-table -->
</div>
<!-- end content-container -->